import React from 'react';
import toast from 'react-hot-toast';

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
  toast.success('Copied to clipboard');
};

export const CopyButton: React.FC<{ text: string; className?: string }> = ({ text, className = "" }) => {
  return (
    <button
      onClick={() => copyToClipboard(text)}
      className={`inline-flex items-center justify-center p-1 text-gray-400 hover:text-gray-600 transition-colors ${className}`}
      title="Copy to clipboard"
    >
      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    </button>
  );
};
